import { StickyLayout } from "@/basic/layouts";

import { NotFoundContent } from "./NotFoundContent";

export const NotFound = () => {
  return (
    <StickyLayout>
      <NotFoundContent />
    </StickyLayout>
  );
};
